export default __webpack_public_path__ + "static/media/icon-monCompte.895033a0.svg";